import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import useMessageStyles from '../../../hooks/useMessageStyles';
import { useMessageBubbleContext } from './MessageBubbleContext';

export default function MessageMediaMetaOverlay() {
  const { messageMediaMetaOverlaySx, messageMediaMetaTextSx } = useMessageStyles();
  const { metaOverlay } = useMessageBubbleContext();

  if (!metaOverlay?.show) return null;

  const { formattedTime, statusIcon, attribution } = metaOverlay;
  if (!formattedTime && !statusIcon && !attribution) return null;

  return (
    <Box sx={messageMediaMetaOverlaySx} aria-hidden="true">
      <Stack direction="row" spacing={0.375} alignItems="center" justifyContent="flex-end">
        {attribution && (
          <Typography component="span" sx={messageMediaMetaTextSx} noWrap>
            {attribution}
          </Typography>
        )}
        {formattedTime && (
          <Typography component="span" sx={messageMediaMetaTextSx}>
            {formattedTime}
          </Typography>
        )}
        {statusIcon && (
          <Box component="span" sx={{ display: 'inline-flex', lineHeight: 1, fontSize: 13 }}>
            {statusIcon}
          </Box>
        )}
      </Stack>
    </Box>
  );
}
